<template>
  <div class="absolute inset-x-0 top-0 h-0.5 overflow-hidden bg-[#ece8fd]">
    <div class="sweep h-full w-[30%] bg-primary" />
  </div>
</template>

<script setup lang="ts">
</script>

<style scoped>
.sweep {
    animation: sweep 1s linear infinite;
}

@keyframes sweep {
    from {
        transform: translateX(-100%);
    }

    to {
        transform: translateX(320%);
    }
}
</style>
